
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 426.667 426.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M138.667 192c17.707 0 32-14.293 32-32s-14.293-32-32-32-32 14.293-32 32 14.293 32 32 32zM288 192c17.707 0 32-14.293 32-32s-14.293-32-32-32-32 14.293-32 32 14.293 32 32 32zM213.333 298.667c-31.467 0-58.667-17.28-73.493-42.667h-35.733c17.067 43.627 59.52 74.667 109.227 74.667s92.16-31.04 109.227-74.667h-35.733C272 281.387 244.8 298.667 213.333 298.667z"}}),_c('path',{attrs:{"d":"M213.12 0C95.36 0 0 95.573 0 213.333s95.36 213.333 213.12 213.333c117.973 0 213.547-95.573 213.547-213.333S331.093 0 213.12 0zm.213 384c-94.293 0-170.667-76.373-170.667-170.667S119.04 42.667 213.333 42.667 384 119.04 384 213.333 307.627 384 213.333 384z"}})])
          )
        }
      }
    